// Disclaimer newsletter del footer: ora nel markup (sections/footer-new.liquid), non più inserito dopo 3 secondi



// Gestione logo mobile per header trasparente e normale
document.addEventListener('DOMContentLoaded', function () {
  let attempts = 0;

  function changeLogo() {
    const logoSelectors = [
      'h1.header__heading img.header__heading-logo',
      '.header-wrapper img.header__heading-logo'
    ];

    let logo = null;

    for (const selector of logoSelectors) {
      logo = document.querySelector(selector);
      if (logo) break;
    }

    if (logo) {
      if (window.innerWidth <= 768) {
        const stickyHeader = document.querySelector('sticky-header');

        if (stickyHeader && stickyHeader.classList.contains('header-transparent')) {
          // Logo per header trasparente
          logo.src = 'https://cdn.shopify.com/s/files/1/0599/1927/0084/files/SPIRULINA-Logo_bianco.svg?v=1736323791';
          logo.srcset = 'https://cdn.shopify.com/s/files/1/0599/1927/0084/files/SPIRULINA-Logo_bianco.svg?v=1736323791 1x';
        } else {
          // Logo per header normale
          logo.src = 'https://cdn.shopify.com/s/files/1/0599/1927/0084/files/logo_mobile.png?v=1638286809';
          logo.srcset = 'https://cdn.shopify.com/s/files/1/0599/1927/0084/files/logo_mobile.png?v=1638286809 1x';
        }
      }
      return true;
    }

    return false;
  }

  const checkLogoInterval = setInterval(() => {
    attempts++;
    if (changeLogo() || attempts > 20) {
      clearInterval(checkLogoInterval);
    }
  }, 500);

  const observer = new MutationObserver(() => {
    if (changeLogo()) {
      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  setTimeout(() => {
    observer.disconnect();
    clearInterval(checkLogoInterval);
  }, 10000);

  setTimeout(() => {
    changeLogo();
  }, 2000);

  // Rilevamento del cambio dello stato di trasparenza dell'header
  window.addEventListener('resize', changeLogo);
  window.addEventListener('scroll', changeLogo);
});



//gestione lingua menu mobile
document.addEventListener('DOMContentLoaded', function () {
  // Desktop
  const desktopLanguageButton = document.getElementById('desktop-language-button');
  const desktopLanguageMenu = document.getElementById('language_form_desktop');

  if (desktopLanguageButton && desktopLanguageMenu) {
    desktopLanguageButton.addEventListener('click', function (e) {
      e.stopPropagation();
      desktopLanguageMenu.classList.toggle('active');
    });

    document.addEventListener('click', function (e) {
      if (!desktopLanguageMenu.contains(e.target)) {
        desktopLanguageMenu.classList.remove('active');
      }
    });
  }

  // Mobile
  const mobileLanguageButton = document.getElementById('mobile-language-button');
  const mobileLanguageMenu = document.getElementById('language_form_mobile');

  if (mobileLanguageButton && mobileLanguageMenu) {
    mobileLanguageButton.addEventListener('click', function (e) {
      e.stopPropagation();
      mobileLanguageMenu.classList.toggle('active');
    });

    document.addEventListener('click', function (e) {
      if (!mobileLanguageMenu.contains(e.target)) {
        mobileLanguageMenu.classList.remove('active');
      }
    });
  }
});


//gestione banner home cliccabile
document.addEventListener("DOMContentLoaded", function() {
    const heroSection = document.querySelector('.hero-bg-video');
    const heroButton = document.querySelector('.hero-banner-btn a');

    if (heroSection && heroButton) {
        heroSection.style.cursor = 'pointer';

        heroSection.addEventListener('click', function() {
            window.location.href = heroButton.href;
        });

        const clickableElements = document.querySelectorAll('.hero-banner-wrap, .hero-banner-content, h1, p');
        clickableElements.forEach(element => {
            element.style.cursor = 'pointer';
            element.addEventListener('click', function(event) {
                event.stopPropagation();
                window.location.href = heroButton.href;
            });
        });
    }
});

//gestione scomparsa trusted shop quando apro menu mobile
document.addEventListener("DOMContentLoaded", function () {
    function initializeScript() {
       
        const widgetContainer = document.getElementById("trustbadge-container-98e3dadd90eb493088abdc5597a70810");
        const menuDrawer = document.getElementById("menu-drawer");
        const shopifyChat = document.getElementById("shopify-chat");
        // Controlla che entrambi gli elementi esistano
        if (!widgetContainer || !menuDrawer || !shopifyChat) {
            console.warn("Widget o menu mobile non trovato. Riprovo...");
            setTimeout(initializeScript, 200);
            return;
        }

        console.log("Script in esecuzione.");

      
        function toggleWidget() {
            if (menuDrawer.classList.contains("show")) {
                widgetContainer.style.display = "none"; // Nascondi il widget
                shopifyChat.style.display = "none";
            } else {
                widgetContainer.style.display = "block"; // Mostra il widget
                shopifyChat.style.display = "block";
            }
        }

      
        const observer = new MutationObserver(() => toggleWidget());
        observer.observe(menuDrawer, { attributes: true, attributeFilter: ["class"] });

       
        document.addEventListener("click", function (event) {
            const closeButton = event.target.closest(".menu-drawer__close-button");
            const menuItem = event.target.closest(".menu-drawer__menu-item");

            if (closeButton || menuItem) {
                setTimeout(toggleWidget, 300); 
            }
        });
    }

 
    initializeScript();
});
//apertura sottomenu corrotta

//gesione scroll banner hero mobile guarantees
/*
document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector("#shopify-section-template--24642778169683__icon_text_jGNNtG .icon-text-wrap");
  const items = container.querySelectorAll(".icon-text-item");
  let index = 0;

  function autoScroll() {
    index++;
    if (index >= items.length) {
      index = 0; // Torna al primo elemento
    }
    const scrollPosition = items[index].offsetLeft;
    container.scrollTo({
      left: scrollPosition,
      behavior: "smooth"
    });
  }

  // Imposta l'intervallo di scorrimento a 5 secondi
  setInterval(autoScroll, 5000);
});*/
